import {CSSProperties, forwardRef, Ref} from 'react';

interface IProps {
  style?: CSSProperties;
  className?: string;
  isCustom?: boolean;
}

// TODO: 처음에는 gradient가 없다가, 스크롤을 내렸을 때 나타나는 페이지 대응 (ex. 작품홈, 이벤트 페이지)
function HeaderGradient(
  {style, className, isCustom}: IProps,
  ref: Ref<HTMLDivElement>
) {
  return (
    <div
      ref={ref}
      className={cn(
        'fixed top-0 left-0 right-0 z-navigationBarMinus2',
        className,
        {
          'bg-background/[0.97]': !isCustom,
          'h-default-gradient-header-height': !isCustom,
        }
      )}
      style={style}
    />
  );
}

export default forwardRef(HeaderGradient);
